import translation from 'locales/translation';
import { ToastTypes } from 'plataforma-fundacao-componentes';
import { Dispatch } from 'react';
import { getAgenda } from 'services/assessor';

export const REORDER_PAUTA_SET_EVENT = 'REORDER_PAUTA_SET_EVENT';
export const REORDER_PAUTA_LIST = 'REORDER_PAUTA_LIST';
export const REORDER_PAUTA_LIST_LOADING = 'REORDER_PAUTA_LIST_LOADING';
export const REORDER_PAUTA_REQUEST = 'REORDER_PAUTA_REQUEST';
export const REORDER_PAUTA_INITIAL_LIST = 'REORDER_PAUTA_INITIAL_LIST';

export const loadPautas = (
  showToast: any,
  state: any,
  dispatch: Dispatch<any>
) => {
  dispatch({ type: REORDER_PAUTA_LIST_LOADING, payload: true });

  return getAgenda(state.eventId)
    .then(({ data }) => {
      dispatch({
        type: REORDER_PAUTA_LIST,
        payload: data.elements.sort(
          (a: { ordem: number }, b: { ordem: number }) =>
            a.ordem < b.ordem ? -1 : 1
        ),
      });
      dispatch({
        type: REORDER_PAUTA_INITIAL_LIST,
        payload: data.elements.sort(
          (a: { ordem: number }, b: { ordem: number }) =>
            a.ordem < b.ordem ? -1 : 1
        ),
      });
    })
    .catch(() => {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label: translation.ComputeVotes.errLoadPauta,
      });
    })
    .finally(() => {
      dispatch({ type: REORDER_PAUTA_LIST_LOADING, payload: false });
    });
};
